module.exports = __webpack_public_path__ + "media/components/Shared/LazyLoad/noimage-8bb7a46396f90420cf8d6f1d55f33848.png";